import axios from 'axios';
import Cookies from 'universal-cookie';
import { SET_FERIADOS, SET_LOADING } from "../../constans/action-types";
import { URL, getAuthorizationHeader } from '../../constans/constants';
import { logout } from '../login/SesionService';

const cookies = new Cookies();
const defaultPage = 0;
const defaultSize = 10;

export const setFeriados = payload => ({ type: SET_FERIADOS, payload });
export const setLoading = payload => ({ type: SET_LOADING, payload });


export const getFeriados = (page = defaultPage, size = defaultSize, anio, search) => {
  return dispatch => {
    let urlRequest = "";
    const idEmpresa = cookies.get('empresa');

    const params = [];
    if (page != null) params.push(`page=${page}`);
    if (size != null) params.push(`size=${size}`);
    if (anio != null && anio !== '') params.push(`anio=${anio}`);
    if (search != null && search !== '') params.push(`search=${encodeURIComponent(search)}`);
    if (idEmpresa != null && idEmpresa !== undefined) params.push(`idEmpresa=${idEmpresa}`);

    urlRequest = URL + "feriados/listar" + (params.length ? `?${params.join("&")}` : "");

    return axios.get(urlRequest, getAuthorizationHeader())
      .then(res => {
        dispatch(setFeriados({
          page: res.data.page.pageable.pageNumber,
          totalCount: res.data.page.totalElements,
          feriados: res.data.page.content
        }));
      }, error => {
        if (error.response.status === 401) {
          logout();
        }
        return error;
      });
  };
};


export const registrarFeriado = (feriado) => {
  return dispatch => {
    dispatch(setLoading(true));
    const idEmpresa = cookies.get('empresa');
    const json = {
      anio: feriado.anio,
      mes: feriado.mes,
      dia: feriado.dia,
      descripcion: feriado.descripcion,
      // username NO se envía: sale del JWT en backend
    };

    return axios.post(URL + 'feriados/registrar/'+idEmpresa, json, getAuthorizationHeader())
      .then(response => {
        dispatch(setLoading(false));
        return response.data;
      }, error => {
        if (error?.response?.status === 401) logout();
        dispatch(setLoading(false));
        return error;
      });
  };
};

export const obtenerFeriado = (id) => {
  return axios.get(URL + 'feriados/obtener/' + id, getAuthorizationHeader())
    .then(response => response.data, error => {
      if (error?.response?.status === 401) logout();
      return error;
    });
};


export const editarFeriado = (id, feriado) => {
  return dispatch => {
    dispatch(setLoading(true));
const idEmpresa = cookies.get('empresa');
    const json = {
      anio: feriado.anio,
      mes: feriado.mes,
      dia: feriado.dia,
      descripcion: feriado.descripcion
    };

    return axios.post(URL + 'feriados/editar/'+idEmpresa+'/' + id, json, getAuthorizationHeader())
      .then(response => {
        dispatch(setLoading(false));
        return response.data;
      }, error => {
        if (error?.response?.status === 401) logout();
        dispatch(setLoading(false));
        return error;
      });
  };
};


export const eliminarFeriado = (id) => {
  return dispatch => {
    dispatch(setLoading(true));

    return axios.delete(URL + 'feriados/eliminar/' + id, getAuthorizationHeader())
      .then(response => {
        dispatch(setLoading(false));
        return response.data;
      }, error => {
        if (error?.response?.status === 401) logout();
        dispatch(setLoading(false));
        return error;
      });
  };
};
